import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { removeAccessTokenFromLocalStorage } from 'utils/local-storage';

const LogInButton = () => {
  const navigate = useNavigate();

  const onSignIn = () => {
    navigate(ROUTES.dynamic.signIn());
    removeAccessTokenFromLocalStorage();
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      size="large"
      onClick={onSignIn}
      startIcon={<AccountCircleIcon />}
    >
      LOG IN
    </Button>
  );
};
export default LogInButton;
